// the contry id get from https://www.iban.com/country-codes
// devDomains are domains that were used in the dev stage and may not disappear all of sudden.
export default {
  ES: {
    id: '978',
    lang: ['es-ES', 'en-ES'],
    langShort: ['es', 'en'],
    currency: 'EUR',
    domain: ~location.host.indexOf('proyectoarise.es') ? 'proyectoarise.es' : 'miravia.es',
    // 过度期，先兼容 proyectoarise.es, 往后废弃,
    regionID: 'ES',
    devDomains: ['pre-www.proyectoarise.es'],
    nameCN: '西班牙',
    nameEN: 'Spain',
    countryCallingCode: '+34'
  },
  FR: {
    id: '458',
    currency: 'EUR',
    lang: ['fr-FR', 'en-FR'],
    langShort: ['fr', 'en'],
    domain: ~location.host.indexOf('proyectoarise.es') ? 'proyectoarise.es' : 'miravia.es',
    // 过度期，先兼容 proyectoarise.es, 往后废弃,
    regionID: 'FR',
    devDomains: ['pre-www.proyectoarise.fr'],
    nameCN: '法国',
    nameEN: 'France',
    countryCallingCode: '+33'
  },
  DE: {
    id: 'null',
    nameCN: '德国',
    nameEN: 'Germany',
    countryCallingCode: '+49'
  },
  IT: {
    id: 'null',
    nameCN: '意大利',
    nameEN: 'Italy',
    countryCallingCode: '+39'
  },
  GB: {
    id: 'null',
    nameCN: '英国',
    nameEN: 'United Kingdom',
    countryCallingCode: '+44'
  },
  TR: {
    id: 'null',
    nameCN: '土耳其',
    nameEN: 'Turkey',
    countryCallingCode: '+286'
  },
  CZ: {
    id: 'null',
    nameCN: '捷克',
    nameEN: 'Czech',
    countryCallingCode: '+450'
  },
  DZ: {
    id: 'null',
    nameCN: '阿尔及利亚',
    nameEN: 'Algeria',
    countryCallingCode: '+213'
  },
  IE: {
    id: 'null',
    nameCN: '爱尔兰',
    nameEN: 'Ireland',
    countryCallingCode: '+353'
  },
  EE: {
    id: 'null',
    nameCN: '爱沙尼亚',
    nameEN: 'Estonia',
    countryCallingCode: '+372'
  },
  AT: {
    id: 'null',
    nameCN: '奥地利',
    nameEN: 'Austria',
    countryCallingCode: '+43'
  },
  BG: {
    id: 'null',
    nameCN: '保加利亚',
    nameEN: 'Bulgaria',
    countryCallingCode: '+359'
  },
  BE: {
    id: 'null',
    nameCN: '比利时',
    nameEN: 'Belgium',
    countryCallingCode: '+32'
  },
  PL: {
    id: 'null',
    nameCN: '波兰',
    nameEN: 'Poland',
    countryCallingCode: '+48'
  },
  DK: {
    id: 'null',
    nameCN: '丹麦',
    nameEN: 'Denmark',
    countryCallingCode: '+45'
  },
  FI: {
    id: 'null',
    nameCN: '芬兰',
    nameEN: 'Finland',
    countryCallingCode: '+358'
  },
  NL: {
    id: 'null',
    nameCN: '荷兰',
    nameEN: 'Netherlands',
    countryCallingCode: '+31'
  },
  HR: {
    id: 'null',
    nameCN: '克罗地亚',
    nameEN: 'Croatia',
    countryCallingCode: '+385'
  },
  LV: {
    id: 'null',
    nameCN: '拉脱维亚',
    nameEN: 'Latvia',
    countryCallingCode: '+371'
  },
  LU: {
    id: 'null',
    nameCN: '卢森堡',
    nameEN: 'Luxembourg',
    countryCallingCode: '+352'
  },
  MA: {
    id: 'null',
    nameCN: '摩洛哥',
    nameEN: 'Morocco',
    countryCallingCode: '+212'
  },
  PT: {
    id: 'null',
    nameCN: '葡萄牙',
    nameEN: 'Portugal',
    countryCallingCode: '+351'
  },
  SE: {
    id: 'null',
    nameCN: '瑞典',
    nameEN: 'Sweden',
    countryCallingCode: '+46'
  },
  CH: {
    id: 'null',
    nameCN: '瑞士',
    nameEN: 'Switzerland',
    countryCallingCode: '+41'
  },
  SK: {
    id: 'null',
    nameCN: '斯洛伐克',
    nameEN: 'Slovakia',
    countryCallingCode: '+421'
  },
  SI: {
    id: 'null',
    nameCN: '斯洛文尼亚',
    nameEN: 'Slovenia',
    countryCallingCode: '+386'
  },
  TN: {
    id: 'null',
    nameCN: '突尼斯',
    nameEN: 'Tunisia',
    countryCallingCode: '+216'
  },
  GR: {
    id: 'null',
    nameCN: '希腊',
    nameEN: 'Greece',
    countryCallingCode: '+30'
  },
  HU: {
    id: 'null',
    nameCN: '匈牙利',
    nameEN: 'Hungary',
    countryCallingCode: '+36'
  }
};